export const SERVICE_OPTIONS = [
  "Roof Replacement",
  "Roof Restoration",
  "Repair/Maintenance",
  "Gutter Replacement",
];

export const SANDBOX_FIXED_ADDRESS = "61 Cope St, Sydney, Redfern, Australia";

export const INITIAL_FORM = {
  service: "",
  fullName: "",
  phone: "",
  email: "",
  address: SANDBOX_FIXED_ADDRESS,
};

export const buildFormMessage = (form) =>
  `Hi, I need ${form.service} at ${form.address}. ${form.fullName}, ${form.phone}, ${form.email}`;

export const generateSandboxPhone = () => {
  const eightDigits = Math.floor(Math.random() * 100_000_000)
    .toString()
    .padStart(8, "0");
  return `+614${eightDigits}`;
};

export const extractPhoneFromFormMessage = (content) => {
  const match = content?.match(/,\s*(\+?\d[\d\s-]{8,20}),\s*[^\s@]+@[^\s@]+/);
  return match?.[1]?.trim() ?? "";
};

export const SANDBOX_DEMO_ROOF_PHOTO_PREVIEW = "/images/thumbnail_roofing.png";

export const SANDBOX_ROOF_PHOTO_MESSAGE = "Here are photos of the roof";

export const buildRoofPhotoMessage = () => SANDBOX_ROOF_PHOTO_MESSAGE;

export const isRoofPhotoMessage = (content) =>
  typeof content === "string" && content.trim() === SANDBOX_ROOF_PHOTO_MESSAGE;
